import React from 'react';

import {formatDate} from 'utils/datetime';
import Avatar from 'components/Avatar';
import Button from 'components/Button';

import './styles.css';

const CustomerInfo = ({
  gocardlessCustomer,
  openCancelGocardlessCustomerModal
}) => {
  return (
    <div className="CustomerInfo">
      <div className="userInfo">
        <Avatar
          className="avatar"
          url={
            gocardlessCustomer.internalAvatarCropped ||
            gocardlessCustomer.avatarCropped
          }
          initials={gocardlessCustomer.initials}
        />
        <div className="text">
          <h5 className="name">{gocardlessCustomer.name}</h5>
          <p className="dateCreated">
            {formatDate(gocardlessCustomer.createdAt)}
          </p>
        </div>
      </div>
      <div className="cancelCustomerButton">
        <Button
          red
          onClick={() =>
            openCancelGocardlessCustomerModal(gocardlessCustomer.id)
          }>
          Cancel customer
        </Button>
      </div>
    </div>
  );
};

export default CustomerInfo;
